// extracted by mini-css-extract-plugin
export default {"containerAlert":"MessageWarning_containerAlert__vLrOh","textAlert":"MessageWarning_textAlert__BS4IR"};